export const style = {
  box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      color: 'action.active',
      gap: 1,
      pt: 1,
    },
  },
  errorMessage: {
    sx: {
      ml: 1,
    },
  },
} as const;
